// document.addEventListener("DOMContentLoaded", function () {
//   const items = document.querySelectorAll(
//     'body:not(.mobile-nav) .wt-page-nav-mega__item--simple.wt-page-nav-mega__item--parent'
//   );

//   items.forEach(item => {
//     const rect = item.getBoundingClientRect();
//     const offsetLeft = rect.left;

//     const sublist = item.querySelector('.wt-page-nav-mega__sublist');
    
//     if (sublist) {
//       sublist.style.paddingLeft = offsetLeft + 'px';
//     }
//   });
// });


function updateMegaMenu() {
  const items = document.querySelectorAll(
    'body:not(.mobile-nav) .wt-page-nav-mega__item--simple.wt-page-nav-mega__item--parent'
  );

  items.forEach(item => {
    const link = item.querySelector('.wt-page-nav-mega__link--parent > span');
    const sublist = item.querySelector('.wt-page-nav-mega__sublist');

    if (link && sublist) {
      const rect = link.getBoundingClientRect();
      const offsetLeft = rect.left;

      sublist.style.paddingLeft = offsetLeft + 'px';
    }
  });
}

window.addEventListener('load', updateMegaMenu);
window.addEventListener('resize', updateMegaMenu);